import * as React from "react";
import type { SVGProps } from "react";

interface StartShootoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const StartShootout = ({ cancelled = false, ...props }: StartShootoutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M20.75 2.8c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.62 0-1.13-.45-1.23-1.04H3.45c-.1.55-.54.98-1.1 1.03h-.5c-.69 0-1.25-.55-1.25-1.24V5.15c0-1.3 1.05-2.35 2.35-2.35Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.75 3.55c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V5.15c0-.13-.1-.23-.23-.23H2.95c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V5.15c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M7.35 14.93c-.2 0-.35-.06-.45-.2-.1-.13-.12-.31-.07-.54a27 27 0 0 1 .74-2.76A50 50 0 0 1 8.5 8.7H6.3c-.47 0-.71-.2-.71-.58 0-.39.24-.58.71-.58h2.88c.48 0 .71.15.71.44 0 .16 0 .3-.04.43-.03.13-.07.27-.13.43l-.17.45A36 36 0 0 0 8.45 13c-.13.48-.23.92-.32 1.31-.09.42-.35.62-.78.62m4.08 0c-.47 0-.7-.23-.7-.7V8.26c0-.27.06-.45.2-.55q.225-.15.63-.15c.38 0 .66.16.84.47l1.77 3.01 1.74-3c.12-.2.25-.32.4-.39.14-.06.34-.09.58-.09.47 0 .71.23.71.7v5.99c0 .46-.24.7-.71.7s-.71-.24-.71-.7V9.92l-1.34 2.39c-.17.32-.4.48-.68.48-.3 0-.52-.16-.7-.48l-1.33-2.39v4.32c0 .46-.23.7-.7.7Z"
      />
      <g transform="matrix(-.95 .33 .33 .95 22.17 8.55)">
        <path
          fill="#FFF"
          d="m18.02 6.85-.31.87a.79.79 0 0 1-.85.5l-4.64-.6a.79.79 0 0 0-.85.54 4.27 4.27 0 0 1-5.46 2.58c-1.9-.68-3-2.59-2.76-4.52a.76.76 0 0 1-.53 0 .78.78 0 0 1-.46-1A.78.78 0 0 1 3.48 5a4.27 4.27 0 0 1 5.36-2.32c.26.1.4.38.3.64l-.02.06c-.1.29.05.6.34.71l2.11.77c.29.1.61-.04.72-.33.1-.3.42-.44.71-.34l4.55 1.66c.4.15.62.6.47 1.01Z"
        />
        <path
          stroke="#FFF"
          strokeWidth={1.28}
          d="M17.7 5.22a1.43 1.43 0 0 1 .92 1.85l-.31.86a1.43 1.43 0 0 1-1.53.93l-4.64-.6a5.7 5.7 0 0 1-2.7 2.9A4.85 4.85 0 0 1 3.2 9.31a4.95 4.95 0 0 1-.72-2.46 1.45 1.45 0 0 1-.88-.76 1.42 1.42 0 0 1 1.26-2.02 6.17 6.17 0 0 1 2.57-1.92A5.13 5.13 0 0 1 8.83 2c.35.12.57.29.71.45l2.3 1.8 5.86.98Z"
        />
        <path
          stroke="#000"
          strokeWidth={1.04}
          d="m18.02 6.85-.31.87a.79.79 0 0 1-.85.5l-4.64-.6a.79.79 0 0 0-.85.54 4.27 4.27 0 0 1-5.46 2.58c-1.9-.68-3-2.59-2.76-4.52a.76.76 0 0 1-.53 0 .78.78 0 0 1-.46-1A.78.78 0 0 1 3.48 5a4.27 4.27 0 0 1 5.36-2.32c.26.1.4.38.3.64l-.02.06c-.1.29.05.6.34.71l2.11.77c.29.1.61-.04.72-.33.1-.3.42-.44.71-.34l4.55 1.66c.4.15.62.6.47 1.01Z"
        />
        <ellipse
          cx={7.38}
          cy={6.69}
          stroke="#000"
          strokeWidth={0.8}
          rx={1.92}
          ry={1.94}
          transform="rotate(20 7.38 6.7)"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default StartShootout;
